import { render, staticRenderFns } from "./report-view-categories.vue?vue&type=template&id=30f50211&"
import script from "./report-view-categories.vue?vue&type=script&lang=js&"
export * from "./report-view-categories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports